import { render, staticRenderFns } from "./DashSvg.vue?vue&type=template&id=59b5239a&scoped=true&"
import script from "./DashSvg.vue?vue&type=script&lang=js&"
export * from "./DashSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b5239a",
  null
  
)

export default component.exports